<page-loading class="card_loading" *ngIf="loading"></page-loading>

<div class="body" *ngIf="!loading">
  <header>
    <h1 *ngIf="type !== 'PRELANCE'">{{ titleOnline }}</h1>
    <h1 *ngIf="type === 'PRELANCE'">{{ titlePre }}</h1>
    <i icon="close" class="icons_close" (click)="chance('no')"></i>
  </header>

  <section *ngIf="!enableBid">
    <h2>O lance foi encerrado!</h2>
  </section>

  <section *ngIf="!loading && enableBid && phase === 1">
    <h3>Lance Atual: {{ convertMoney((attual_bid || 0) - increment || 0) }}</h3>
    <h3>Gostaria de dar lance no Lote {{ animal.lot || '-' }} - {{ animal.name || (animal.animal || '-') }} ?</h3>
    <h2>{{ convertMoney(next_bid || 0) }}</h2>

    <div class="card_slider">
      <mat-slider
        thumbLabel
        showTickMarks
        step="{{ increment }}"
        min="{{ min_bid }}"
        max="{{ max_bid }}"
        aria-label="units"
        (change)="changeBid($event)"
        [displayWith]="formatLabel"
      ></mat-slider>
    </div>
  </section>

  <section *ngIf="!loading && enableBid && phase === 2">
    <h3>Confirmar valor da compra</h3>
    <h2>{{ convertMoney(next_bid || 0) }}</h2>
  </section>

  <section *ngIf="!loading && enableBid && phase === 3">
    <h3>Tem certeza desse lance?</h3>
    <h2>{{ convertMoney(next_bid || 0) }}</h2>
  </section>

  <section *ngIf="!loading && enableBid && phase === 4">
    <h3>Lance feito com sucesso!</h3>
  </section>

  <footer>
    <button mat-button class="cancell" (click)="chance('no')">FECHAR</button>
    <button
      mat-button
      *ngIf="enableBid && phase !== 4"
      class="primary"
      (click)="nextPhase()"
    >
      {{ phase === 2 ? 'CONFIRMAR' : 'SIM' }}
    </button>
  </footer>
</div>
